import React, { memo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';

const Team = memo(function Team({ data }) {

    if (data) {
        const cellRender = (cellData) => {
            return <img src={cellData.value} alt='Profile' width="25%" /> ;
        }

        return (
            <div className="row">
                <DataGrid
                    dataSource={data}
                    columnAutoWidth={true}
                    showBorders={true}
                >
                    <Column caption="Team Members" alignment="center">  
                        <Column dataField="id" visible={false} />
                        <Column dataField="profilePicture" cellRender={cellRender}/>
                        <Column dataField="name" />
                        <Column dataField="assignedLocation" />
                    </Column>
                </DataGrid>
            </div>
        )
    }
});

export default Team;